import { render, staticRenderFns } from "./principal.vue?vue&type=template&id=2aabb495&scoped=true"
import script from "./principal.js?vue&type=script&lang=js&external"
export * from "./principal.js?vue&type=script&lang=js&external"
import style0 from "./principal.css?vue&type=style&index=0&id=2aabb495&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aabb495",
  null
  
)

export default component.exports